<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-27 09:24:59
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-02-13 09:49:57
 * @Description: 
-->
<!--
 * @Description: 解决方案-案例摘要卡片 (仿制海口置地花园卡片)
-->
<template>
  <div
    class="case-summary-card group relative flex flex-col overflow-hidden bg-white rounded-8px lt-sm:rounded-16px transition-all duration-300 hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] hover:-translate-y-4px border border-transparent hover:border-blue-100"
  >
    <!-- Image Section -->
    <div class="relative w-full aspect-[16/9] overflow-hidden">
      <img
        :src="cover"
        :alt="title"
        class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <!-- Gradient Overlay (Optional, for better text contrast if needed, currently kept clean) -->
      <div
        class="absolute inset-0 bg-black/0 transition-colors duration-300 group-hover:bg-black/2"
      ></div>
    </div>

    <!-- Content Section -->
    <div class="flex flex-col flex-1 p-20px">
      <!-- Title -->
      <h3
        class="font-s-22px lt-sm:font-s-28px text-main pf-sc-semibold mb-16px line-clamp-1 group-hover:text-primary transition-colors"
      >
        {{ title }}
      </h3>

      <!-- Bottom Row: Tags + Logo -->
      <div class="mt-auto flex items-end justify-between">
        <!-- Tags -->
        <div class="flex items-center gap-8px flex-wrap">
          <span
            v-for="(tag, index) in tags"
            :key="index"
            class="px-8px py-4px rounded-4px border border-#E2E8F0 text-#64748B font-s-12px lt-sm:font-s-18px pf-sc-regular bg-white"
          >
            {{ tag }}
          </span>
        </div>

        <!-- Logo -->
        <div v-if="logo" class="flex-shrink-0 ml-12px">
          <i :class="logo" class="h-28px w-124px"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  interface Props {
    title: string
    cover: string
    tags?: string[]
    logo?: string
  }

  withDefaults(defineProps<Props>(), {
    tags: () => [],
    logo: '',
  })
</script>

<style scoped lang="scss">
  .case-summary-card {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  }
</style>
